import { Routes, RouterModule } from '@angular/router';
import { HisBootstrapService, HisAuthGuard } from 'hisng';
import { JobAdvertisementDetailViewComponent } from './component/jobadvertisement-detail-view.component';
import { JobAdvertisementSearchResultComponent } from './component/jobadvertisement-search-result.component';

const JOBADVERTISEMENT_ROUTES: Routes = [
    {
        // Vorgelagerte Route für Generische Suche und Detailseite (siehe unten)
        path: 'jobadvertisement',
        loadChildren: () => import( '../jobadvertisement/jobadvertisement-core.module' ).then( m => m.JobAdvertisementCoreModule ),
        resolve: { boot: HisBootstrapService },
        canActivate: [HisAuthGuard],
        data: {
            hasAll: ['RIGHT_EVERYONE'],
            modules: ['HISINONEBWM']
        }
    },
    {
        // Generische Suche nach Stellenausschreibungen (Akkordeon)
        path: 'searchresult',
        pathMatch: 'full',
        component: JobAdvertisementSearchResultComponent,
    },
    {
        // Detailseite einer Stellenausschreibung
        path: 'view/:id',
        component: JobAdvertisementDetailViewComponent,
        canActivate: [HisAuthGuard]
    },
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const JobAdvertisementRoutesModule = RouterModule.forChild( JOBADVERTISEMENT_ROUTES );
